<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition">
            <el-form-item label="模糊搜索">
              <el-input v-model="searchCondition.query" placeholder="请输入订单号|公司名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="审核状态">
              <el-select
                v-model="searchCondition.same_name_type"
                class="select-wrapper"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="未审核" value="1"></el-option>
                <el-option label="审核通过" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="标记类型">
              <el-select
                clearable
                filterable
                v-model="searchCondition.tag_id"
                class="select-wrapper"
              >
                <el-option v-for="item in mark_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <ScreeCompany
            :allowField="allowField"
            @ScreeCompany="ScreeCompany"/>
          <div class="table-right">
            <MonthPicker @MonthSearch="MonthSearch"/>
            <el-select v-model="value" placeholder="请选择导出类型" @change="selectData" class="select-box" size="medium">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button :loading="downloadLoading" style="margin:0 0 20px 20px;" type="primary" size="medium"
                       icon="el-icon-document" @click="handleDownload">
              导出
            </el-button>
          </div>
        </el-row>
        <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData"
                  @switchPaging="switchPaging" highlight-current-row>
          <el-table-column
            slot="first-column"
			min-width="150"
            align="left"
            label="公司名称">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.outer_trade_no" placement="top">
                <div type="text">{{ scope.row.company_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="money"
			min-width="180"
            align="center"
            sortable
            label="充值金额">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="warning">¥ {{ scope.row.money }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
			min-width="180"
            prop="tax_money"
            sortable
            label="服务费">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="warning">¥ {{ scope.row.tax_money }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="tax_money"
            label="充值状态">
            <template slot-scope="scope">
              <div class="center" :class="scope.row.same_name_type?'red':''">
                {{scope.row.same_name_type?"失败":"成功"}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="is_collect"
            sortable
            label="是否收取服务费"
            width="150">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag v-if="scope.row.is_collect == '11'" type="success">成功</el-tag>
                <el-tag v-else type="danger">失败</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
          align="center"
            prop="status"
            label="审核状态"
            width="150">
            <template slot-scope="scope">
              <div class="center" :class="(scope.row.same_name_type && scope.row.is_refuse==0)?'blue':''">
                <span v-if="scope.row.is_refuse">{{ scope.row.is_refuse?"已驳回":"未驳回"}}</span>
                <span v-else>{{scope.row.same_name_type?"待审核":"审核通过"}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="tag_id"
            align="center"
            label="标记"
          >
            <template slot-scope="scope">
              <div>
                {{ mark_list_obj[scope.row.tag_id] || '' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="230" v-if="userPermissions.indexOf('recharge_audit') != -1" align="center" label="操作">
            <template slot-scope="scope">
              <el-button size="medium" v-if="userPermissions.indexOf('recharge_audit') != -1 && scope.row.same_name_type===1 && scope.row.is_refuse==0" type="text" @click="initReject(scope.row)">驳回</el-button>
              <el-popover v-if="userPermissions.indexOf('recharge_audit') != -1 && scope.row.same_name_type==1 && scope.row.is_refuse==0" :ref="'el-popover-'+scope.$index" placement="top">
                <p>确定要通过吗？</p>
                <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini"
                        @click="$refs['el-popover-'+scope.$index].doClose()">取消</el-button>
                    <el-button type="primary" size="mini" @click="verifyButton(scope.row.outer_trade_no)">确定
                    </el-button>
                </div>
                <el-button size="medium" slot="reference" type="text">审核通过</el-button>
              </el-popover>
              <el-button type="text" size="medium" @click="setMark(scope.row)">标记</el-button>

            </template>
          </el-table-column>
        </ApeTable>
      </div> 
    </PageHeaderLayout>

    <RejectForm
      :dialog-data="rejectFormDialog"
      :deliver-data="deliverData"
      @confirm="rejectFormConfirm"
    />

    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="rules" ref="set_mark_ref" label-position="right" label-width="150px">
          <el-form-item label="标记类型" prop="tag_id">
            <el-select
              v-model="formData.tag_id"
              placeholder="请选择标记类型"
              size="medium"
            >
              <el-option
                v-for="item in mark_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData.tag_id===99" label="关联个人" prop="id_number">
            <el-select
              v-model="formData.id_number"
              placeholder="请选择人员"
              size="medium"
              filterable
            >
              <el-option
                v-for="item in select_customer_list"
                :key="item.id_number"
                :label="item.name + ' - '+item.id_number"
                :value="item.id_number"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
import MonthPicker from '@/components/MonthPicker.vue'
import RejectForm from '@/components/RejectForm.vue' 
import ModalDialog from "@/components/ModalDialog.vue";

import {
    mapGetters
} from 'vuex'

export default {
  components: {
    ModalDialog,
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    ScreeCompany,
    MonthPicker,
    RejectForm
  },
  data() {
    return {
      rules: {
        tag_id: [{required: true, message: '选择类型', trigger: 'change'}],
        id_number: [{required: true, message: '请选择人员', trigger: 'change'}]
      },
      formData:{
        tag_id:'',
        id:'',
        id_number:''
      },
      mark_list:[],
      select_customer_list:[],
      mark_list_obj:{},
      dialogData:{
        visible: false,
        title: '设定标记',
        width: '30%',
        loading: false,
        modal: false
      },
      deliverData:{},
      rejectFormDialog: {
        visible: false,
        width: "55%",
        loading: false,
        modal: true,
        confirmText: "驳回",
        title: "发起驳回",
      },
      // 允许显示的字段
      allowField: ['companyId', 'settlementId'],
      companyId: '',
      // 搜索条件
      searchCondition: {},
      downloadLoading: false,
      options: [{
        value: 'xlsx',
        label: 'xlsx'
      }, {
        value: 'csv',
        label: 'csv'
      }, {
        value: 'txt',
        label: 'txt'
      }
      ],
      value: 'xlsx',
      bookType: 'xlsx',//导出表格类型
      loadingStaus: true,
      columns: [
        {
          title: '收款方',
          width: 300,
          value: [
            {label: '付款户名：', value: 'payer_card_name'},
            {label: '付款帐号：', value: 'payer_card_no'},
            {label: '收款户名：', value: 'payee_card_name'},
            {label: '收款帐号：', value: 'payee_card_no'},
          ],
          header_align: 'center',
        },
  /*      {
          title: '税源地名称',
          value: 'channel_name',
          header_align: 'center',
          align: 'center',
        },*/
        {
          title: '备注',
          value: 'payer_remark',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '创建时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center',
        }
      ],
      dataList: [],// 表格列表数据
      pagingData: {// 分页信息
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      offset: 0,// 分页的offset,序号列使用
    }
  },
  computed: {
        ...mapGetters(['userPermissions'])
  },
  methods: {
    async getSelectCustomerList(company_id,channel_account){
      let data = {
        channel_account,
        company_id,
        current_page:1,
        page_size:9999
      }
      let result = await this.$api.getSelectCustomerList(data)
      this.select_customer_list = result

      console.log(this.mark_list,'标记列表')
    },
    async getMarkList(){
      let result = await this.$api.getRechargeMarkList()
      let mark_list = []
      for(let key in result){
        let item = {
          value:+key,
          label:result[key]
        }
        mark_list.push(item)
      }
      this.mark_list = mark_list
      this.mark_list_obj = result
      console.log(this.mark_list,'标记列表')
    },
    setMark(e){
      this.formData.id = e.id;
      this.formData.tag_id = e.tag_id || '';
      this.formData.id_number = (e.tag_id == 99 ? e.id_number : '') || '';
      this.dialogData.visible = true;
      this.getSelectCustomerList(e.company_id, e.channel_account)
    },
    async confirmSetMark(){
      let formData = {
        ...this.formData
      }
      let result = await this.$api.setRechargeMark(formData)
      if(result){
        this.loading = true;
        setTimeout(()=>{
          this.loading = false;
          this.dialogClose()
          this.init()
        },500)
      }
    },
    // 设定标记相关
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['set_mark_ref'].validate((valid) => {
        if (valid) {
          this.confirmSetMark()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
    },
      rejectFormConfirm(){
        this.init()
      },
      initReject(item) {
        console.log(item,'驳回')
        let {company_id, company_name,payer_card_name,channel_name,payer_card_no, money, tax_money, channel_account, id} = item
        this.deliverData = {
          company_id,
          company_name,
          payer_card_name,
          bank_account_no:payer_card_no,
          money,
          channel_account,
          channel_name,
          tax_money,
          id
        };
        this.rejectFormDialog.visible = true;

      },
      // 审核用户
      async verifyButton(outer_trade_no) {
        let data ={
            outer_trade_no,
            status:1
        }
        let result = await this.$api.postRechargeEdit(data)
        if (result) {
            this.$message.success('提交成功')
            this.init()
        }
      },
    // 导出日期
    MonthSearch(v) {
      if (v) {
        this.searchCondition.time_value = v
      }
      this.init('search')
    },
    ScreeCompany(v, name) {
      if (name == 'company') {
        if (v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }
      if (name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    //选择导出类型
    selectData(e) {
      this.bookType = e;
    },
    //导出
    async handleDownload() {
      this.isExport = true;
      this.downloadLoading = true
      let list = await this.init('export')
      import('@/excel/Export2Excel').then(excel => {
        const tHeader = ['公司名称', '充值金额', '服务费', '备注', '付款户名', '付款账号', '收款户名', '收款账号', '创建时间'];
        const data = this.formatJson(list)
        const time = new Date().getTime() + Math.random() * 1000
        let filename = `充值明细${time}`
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType //Optional
        })
        this.downloadLoading = false;
      })
    },
    //转换导出数据
    formatJson(jsonData) {
      return jsonData.map(v => {
        let {
          company_name,
          money,
          tax_money,
          payer_remark,
          payer_card_name,
          payer_card_no,
          payee_card_name,
          payee_card_no,
          created_at
        } = v
        return [company_name, money, tax_money, payer_remark, payer_card_name, payer_card_no, payee_card_name, payee_card_no, created_at]
      })
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.query) {
        condition.query = this.searchCondition.query
      }
      if (this.searchCondition.same_name_type) {
        condition.same_name_type = this.searchCondition.same_name_type
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        }
      }
      if (this.searchCondition.company_id) {
        condition.company_id = this.searchCondition.company_id
      }
      if (this.searchCondition.channel_account) {
        condition.channel_account = this.searchCondition.channel_account
      }
      if (this.searchCondition.tag_id) {
        condition.tag_id = this.searchCondition.tag_id;
      }
      return condition
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化
    async init(type) {
      let pagingInfo = this.$refs['apeTable']?.getPagingInfo(type) || {
        page_size:10,
        current_page:1
      }
      if (type == 'export') {
        pagingInfo.page_size = 50000
      } else {
        this.loadingStaus = true
      }
      if (type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      let {data, pages} = await this.$api.getMxRechargeList(searchCondition)
      if (type == 'export') {
        return data
      } else {
        this.dataList = data
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus = false
        this.dataList.forEach(item => {
          let companyIds = this.$config.domain?.settlmentlCustom?.companyIds||[]
          if(companyIds.length){
              companyIds.forEach(i => {
                if (this.companyId == i) {
                  if (item.payee_card_name == this.$config.domain.settlmentlCustom.originName) {
                    item.payee_card_name = this.$config.domain.settlmentlCustom.currentName
                    item.payee_card_no = this.$config.domain.settlmentlCustom.paymentAccount
                    item.money = this.$config.domain.settlmentlCustom.placeholder
                    item.tax_money = this.$config.domain.settlmentlCustom.placeholder
                  }
                }
              })
          }
          
        })
      }
    },
  },
  async mounted() {
    await this.getMarkList()
    // this.init()
  },
}
</script>

<style lang="stylus" scoped>
.blue
  color #1890FF
.red
  color #F56C6C
.el-button
  margin-right 4px
  margin-bottom 4px

.table-header
  margin-bottom 12px

.el-popover .el-checkbox-group .el-checkbox
  margin-left 0px
  margin-right 12px

.table-right
  float: right;

.select-box
  width: 100px

.returnBtn
  position: relative
  top: 10px
  float: right

.table-search
  height: 36px
</style>
